import { render, staticRenderFns } from "./preview-media.vue?vue&type=template&id=1f1ba64c&scoped=true&"
import script from "./preview-media.vue?vue&type=script&lang=js&"
export * from "./preview-media.vue?vue&type=script&lang=js&"
import style0 from "./preview-media.vue?vue&type=style&index=0&id=1f1ba64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ba64c",
  null
  
)

export default component.exports